import { render } from "./CampaignNewsUpdateItem.vue?vue&type=template&id=3eba782c&scoped=true"
import script from "./CampaignNewsUpdateItem.vue?vue&type=script&lang=js"
export * from "./CampaignNewsUpdateItem.vue?vue&type=script&lang=js"

import "./CampaignNewsUpdateItem.vue?vue&type=style&index=0&id=3eba782c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3eba782c"

export default script